import { apiRequest } from './apiClient.js';
import { t } from '../i18n/index.js';

export interface WorkflowProject { id: string; title: string; number?: string | null }
export type ProjectLookupStatus = 'loading' | 'ready' | 'unavailable' | 'error';

/** History and financial tools must also expose archived projects. Creation
 * compatibility remains the responsibility of each authorized domain service. */
export async function loadWorkflowProjects(signal?: AbortSignal): Promise<WorkflowProject[]> {
  const results = await Promise.all([
    apiRequest<{ projects: WorkflowProject[] }>('/api/projects/lookup', { signal }),
    apiRequest<{ projects: WorkflowProject[] }>('/api/projects/lookup?archived=true', { signal }),
  ]);
  if (results.some(result => !Array.isArray(result.projects) || result.projects.some(project => !project?.id || typeof project.title !== 'string'))) throw new Error(t('cohesion.invalidResponse'));
  return [...new Map(results.flatMap(result => result.projects).map(project => [project.id, project])).values()];
}
